import React from "react";
import { Box, Text, Stack, Group, Tooltip, Card, Divider, SegmentedControl } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectAvailableStandardRoomValidationDisciplines,
  selectStandardRoomDisciplineFromActiveRoomColoring,
  selectStandardRoomValidationInfoInSelectedRoom,
} from "../../Room/roomSelectors";
import { StandardRoomDiff } from "./StandardRoomDiff";
import { formatShortDate } from "../../globalUtils";
import {
  IRfpStandardRoomDiscipline,
  setRfpStandardRoomDisciplineInRedux,
} from "../../DesignTab/designSlice";

export const DrofusStandardRoomDiffAllDisciplines: React.FC = () => {
  const dispatch = useAppDispatch();
  const disciplines = useAppSelector(selectAvailableStandardRoomValidationDisciplines);
  const disciplineFromFilter = useAppSelector(selectStandardRoomDisciplineFromActiveRoomColoring);
  const validationInfo = useAppSelector(selectStandardRoomValidationInfoInSelectedRoom);
  const matchRatePct = validationInfo?.summary?.matchRatePct;
  const validatedAt = validationInfo?.validatedAt;

  const activeProjectTab = useAppSelector((s) => s.global.activeProjectTab);
  const rfpStandardRoomDiscipline = useAppSelector((s) => s.design.rfpStandardRoomDiscipline);

  const discipline = activeProjectTab === "room" ? rfpStandardRoomDiscipline : disciplineFromFilter;

  React.useEffect(() => {
    if (
      activeProjectTab === "room" &&
      rfpStandardRoomDiscipline == null &&
      disciplines.length > 0
    ) {
      {
        dispatch(setRfpStandardRoomDisciplineInRedux(disciplines[0] as IRfpStandardRoomDiscipline));
      }
    }
  }, [disciplineFromFilter, dispatch]);

  return (
    <Card
      withBorder
      radius="md"
      w="100%"
      h="calc(100% - 175px)"
      style={{ display: "flex", flexDirection: "column", minHeight: 0 }}
    >
      {/* Header/top - fixed height */}
      <Stack gap="xs" align="flex-start" style={{ flex: "0 0 auto" }}>
        {disciplines.length === 0 && (
          <Text>Ingen tilgjengelige disipliner for standardromvalidering</Text>
        )}

        {disciplines.length > 0 && (
          <Box w="100%">
            <Group justify="space-between" align="center">
              {activeProjectTab === "room" && (
                <SegmentedControl
                  value={discipline}
                  onChange={(value) =>
                    dispatch(
                      setRfpStandardRoomDisciplineInRedux(
                        (value ? `${value}` : undefined) as IRfpStandardRoomDiscipline
                      )
                    )
                  }
                  data={disciplines.map((d: any) => ({
                    value: d,
                    label: `RI${d}`,
                  }))}
                  radius="xl"
                  size="sm"
                  color="blue"
                  transitionDuration={120}
                />
              )}
              {matchRatePct != null && validatedAt != null && (
                <Stack gap={0} align="flex-end" style={{ minWidth: 0 }}>
                  <Group gap="xs">
                    <Text size="xs" c="dimmed">
                      Treffsikkerhet
                    </Text>
                    <Text size="xs" fw={600}>
                      {matchRatePct.toFixed(1)} %
                    </Text>
                  </Group>

                  <Tooltip label={validatedAt} position="bottom-end" withArrow>
                    <Text size="xs" c="dimmed">
                      Sist validert {formatShortDate(validatedAt)}
                    </Text>
                  </Tooltip>
                </Stack>
              )}
            </Group>
          </Box>
        )}
      </Stack>

      <Divider my="xs" />

      {discipline != null && <StandardRoomDiff discipline={discipline} />}
    </Card>
  );
};
